module.exports = __webpack_public_path__ + "mobile/img/icon_add_png.ec399ef4.png";